import moment from 'moment';
import React from 'react';
import { Col, Container, Image, Row, Table } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { NavBarComponente } from '../../Components/NavBarComponente';
import voltar from '../../Imagens/arrow-left-16.png';
import voltarInicio from '../../Imagens/arrow-left-first-16.png';
import proximo from '../../Imagens/arrow-right-16.png';
import proximoUltimo from '../../Imagens/arrow-right-last-16.png';
import fechar from '../../Imagens/close-24.png';
import { MigrationViewModel } from './MigrationModel';

import "../../Estilo/Form.css";
import { TypePagination } from '../TableGeneric/TableGenericViewController';

interface MyProps {
    navigation: any
    delegate: MigrationViewControllerDelegate
    viewModel: MigrationViewModel
}

export interface MigrationViewControllerDelegate {
    tapDimiss(navigation: any): void
}

export class MigrationViewController extends React.Component<MyProps> {

    state = {
        page: 1,
        countPage: 0,
        countLine: 0,
        isLoading: false,
        result: []
    }

    componentDidMount() {
        this.loadStruct(this.state.page)
    }

    render() {
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Migrations Executadas</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>

                    </Container>
                    <div className="tableData">
                        <Table responsive={true}>
                            <thead className="tableDataHead">
                                <tr>
                                    <th>ID</th>
                                    <th>Versão</th>
                                    <th>Data</th>
                                </tr>

                            </thead>
                            <tbody className="tableDataBody">
                                {this.state.result.map((item: any) => (
                                    <tr>
                                        <td>{item.id}</td>
                                        <td>{item.versao} </td>
                                        <td>{moment(item.data_execucao).format('HH:mm:ss DD/MM/YYYY')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                    <div className="tableContainerNav">
                        <Container fluid={true}>
                            <Row>
                                <Col xs="12">
                                    <div style={{ height: 30 }}>
                                        <div style={{ float: "right" }}>
                                            <label className="tableCountData">Número de Registros: {this.state.countLine}</label>
                                        </div>
                                        <div style={{ float: "left" }}>
                                            <Image
                                                onClick={() => this.pagination('first')}
                                                style={{ marginLeft: 0, cursor: "pointer" }}
                                                src={voltarInicio}
                                                width={16}
                                                className="center"
                                                fluid />
                                            <Image
                                                onClick={() => this.pagination('back')}
                                                src={voltar}
                                                className="center imageNav"
                                                fluid />
                                            <label className="tablePage">{this.state.page}/{this.state.countPage}</label>
                                            <Image
                                                onClick={() => this.pagination('next')}
                                                src={proximo}
                                                className="center imageNav"
                                                fluid />
                                            <Image
                                                onClick={() => this.pagination('last')}
                                                src={proximoUltimo}
                                                className="center imageNav"
                                                fluid />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <ToastContainer />
                </div >

                {/* Componente de Loader */}
                < LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })
                } />
            </div >
        )
    }

    private loadStruct(page: number) {
        this.setState({ isLoading: true })
        this.props.viewModel.getMigrations(page).then((rs) => {
            this.setState({
                result: rs.resultado,
                isLoading: false,
                countLine: rs.count,
                countPage: rs.count > 0 ? Math.ceil(rs.count / 10) : 1
            })
        }, e => {
            console.log('erro', e)
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    private pagination(type: TypePagination) {

        var page = 0
        switch (type) {
            case 'first':
                page = 1
                break;
            case 'back':
                page = this.state.page == 1 ? 1 : this.state.page - 1
                break;
            case 'next':
                page = this.state.page == this.state.countPage ? this.state.countPage : this.state.page + 1
                break;
            case 'last':
                page = this.state.countPage
                break;
        }

        this.setState({
            page: page
        })

        this.loadStruct(page)
    }
}
